import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getProducts, stockInsertData } from "src/api/commonapi";
import { notification } from "src/utils/messages";
import { useStockUser, useRealUser } from "../CityStockReport/CityStockContext";

export default function StockInsertUpdateModal({
  addEditModal,
  setAddEditModal,
  modalType,
  toggleAddEditModal,
  rowData,
  handleGetProducts,
  filterData
}) {
  const user = useStockUser();
  const realUser = useRealUser();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [stockData, setStockData] = useState({
    p_id: rowData.p_id,
    p_qty: modalType === "Edit" ? rowData.qty : "",
    p_name: rowData.p_name,
    city_id: user?.city_id,
    u_id: realUser?.u_id,
    u_name: realUser?.name,
    date:
      modalType === "Edit"
        ? typeof rowData?.date === "string"
          ? rowData.date.replace(/\./g, "")
          : rowData?.date
        : new Date()
  });

  const resetFormData = () => {
    setStockData({
      p_id: rowData.p_id,
      p_qty: "",
      p_name: rowData.p_name,
      city_id: user?.city_id,
      u_id: realUser?.u_id,
      u_name: realUser?.name,
      date: ""
    });
  };

  const handleInsertStockData = async () => {
    if (
      stockData.p_id != "" &&
      stockData.p_qty != "" &&
      stockData.p_name !== "" &&
      stockData.date !== ""
    ) {
      setLoader(true);
      setIsLoading(true);

      let resp = await stockInsertData({
        ...stockData,
        date:
          stockData.date !== "DD-MM-YYYY"
            ? moment(stockData.date).format("DD-MM-YYYY")
            : stockData.date
      });
      setIsLoading(false);
      if (resp.status != 0) {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        resetFormData();
        toggleAddEditModal();
        handleGetProducts(filterData);
      } else {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
      }
      setLoader(false);
    } else {
      let notify = notification({
        type: "error",
        message: "Please Fill All Fields data"
      });
      notify();
    }
  };

  return (
    <Modal
      open={addEditModal}
      onClose={() => toggleAddEditModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          {/* {modalType} New Stock */}
          {rowData.p_name}
        </Typography>
        <hr />
        {/* <Stack>Product Name : {rowData.p_name}</Stack> */}
        <Stack style={{ marginBottom: "15px" }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Stack spacing={3} style={{ marginBottom: "5px", marginTop: "15px" }}>
                {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  isDisabled
                  style={{ marginTop: "15px" }}
                >
                  <DatePicker
                    type="date"
                    name="date"
                    label="Date"
                    value={stockData?.date ? moment(stockData.date).toDate() : new Date()}
                    inputFormat="dd/MM/yyyy"
                    onChange={(newDate) => {
                      setStockData({
                        ...stockData,
                        date: moment(newDate).format("YYYY-MM-DD")
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 40
                          },
                          "& .MuiInputLabel-root": {
                            top: "-6px" // adjust this to move label vertically
                          }
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
            </Grid>
            <Grid item sm={12} xs={12} md={12} lg={12}>
              <TextField
                height={10}
                size="small"
                fullWidth
                autoComplete="off"
                type="number"
                required
                label="Quantity"
                name="p_qty"
                placeholder="Enter Quantity"
                onChange={(e) => {
                  setStockData({
                    ...stockData,
                    p_qty: e.target.value
                  });
                }}
                value={stockData?.p_qty}
              />
            </Grid>

            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleAddEditModal()}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                onClick={() => !loader && handleInsertStockData()}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
